import type { FaireProductEntity } from "../../entity_types/product";

export const p_ma8yyyesjy: FaireProductEntity = {
  token: "p_ma8yyyesjy",
  type: "product",
  name: "DRIED FRUIT | PINEAPPLE RINGS",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1c67028187e65b8129d7644096acdbbee39d0ec3f2cd97d342d7aa1907ac622c.png",
  priceDollars: 5.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
